// variantes-imagenes.js - Versión COMPLETA con visor navegable y flechas sutiles
document.addEventListener('DOMContentLoaded', function() {
  
  // MAPA DE CÓDIGOS
  var codigosVariantes = {
    'brown mole': 'bm',
    'black carbon': 'bc',
    'green forest': 'gf',
    'red flower': 'fx',
    'black vulture': 'bv',
    'blue royal': 'br',
    'light grey': 'lg',
    'dark grey': 'dg'
  };
  
  // ============================================
  // VISOR DE IMÁGENES CON NAVEGACIÓN
  // ============================================
  var visor = null;
  var visorImg = null;
  var imagenesVisor = [];
  var indiceActual = 0;
  
  function crearVisor() {
    if (visor) return;
    
    visor = document.createElement('div');
    visor.id = 'visor-imagenes';
    visor.style.cssText = `
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.95);
      z-index: 9999999;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    `;
    
    // Contenedor de la imagen
    var contenedorImg = document.createElement('div');
    contenedorImg.style.cssText = `
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `;
    
    visorImg = document.createElement('img');
    visorImg.style.cssText = `
      max-width: 90%;
      max-height: 80%;
      object-fit: contain;
      transition: opacity 0.2s ease;
      cursor: pointer;
    `;
    
    // Botón cerrar (con tamaño responsive)
    var cerrar = document.createElement('button');
    cerrar.innerHTML = 'x';
    cerrar.style.cssText = `
      position: absolute;
      top: 15px;
      right: 15px;
      background: white;
      border: none;
      border-radius: 20%;
      width: 30px;
      height: 30px;
      font-size: 18px;
      cursor: pointer;
      z-index: 10000000;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      border: 2px solid #333;
      transition: all 0.2s ease;
    `;

      // Ajustes específicos para móvil
        if (window.innerWidth <= 768) {
        cerrar.style.width = '36px';
        cerrar.style.height = '36px';
        cerrar.style.fontSize = '18px';
        cerrar.style.top = '10px';
        cerrar.style.right = '10px';
      }

      // Efecto hover (opcional)
      cerrar.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.1)';
      this.style.backgroundColor = '#f0f0f0';
      });
      cerrar.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
      this.style.backgroundColor = 'white';
      });
    
    // Botón anterior (sutil)
    var btnAnterior = document.createElement('button');
    btnAnterior.innerHTML = '‹';
    btnAnterior.style.cssText = `
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      border: none;
      color: white;
      width: 50px;
      height: 50px;
      font-size: 48px;
      cursor: pointer;
      z-index: 10000000;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 0;
      padding-bottom: 8px;
      text-shadow: 0 2px 5px rgba(0,0,0,0.5);
      opacity: 0.1;
      transition: opacity 0.1s ease;
    `;
    
    // Botón siguiente (sutil)
    var btnSiguiente = document.createElement('button');
    btnSiguiente.innerHTML = '›';
    btnSiguiente.style.cssText = `
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      border: none;
      color: white;
      width: 50px;
      height: 50px;
      font-size: 48px;
      cursor: pointer;
      z-index: 10000000;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 0;
      padding-bottom: 8px;
      text-shadow: 0 2px 5px rgba(0,0,0,0.5);
      opacity: 0.1;
      transition: opacity 0.1s ease;
    `;
    
    // Contador de imágenes
    var contador = document.createElement('div');
    contador.id = 'visor-contador';
    contador.style.cssText = `
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0,0,0,0.7);
      color: white;
      padding: 8px 16px;
      border-radius: 30px;
      font-size: 14px;
      font-family: Arial, sans-serif;
      border: 1px solid rgba(255,255,255,0.3);
      z-index: 10000000;
    `;
    
    // Eventos hover para que aparezcan las flechas
    btnAnterior.addEventListener('mouseenter', function() {
      this.style.opacity = '1';
    });
    btnAnterior.addEventListener('mouseleave', function() {
      this.style.opacity = '0.5';
    });
    
    btnSiguiente.addEventListener('mouseenter', function() {
      this.style.opacity = '1';
    });
    btnSiguiente.addEventListener('mouseleave', function() {
      this.style.opacity = '0.5';
    });
    
    // Ajustes para móvil
    if (window.innerWidth <= 768) {
      btnAnterior.style.opacity = '0.8';
      btnSiguiente.style.opacity = '0.8';
      btnAnterior.style.fontSize = '40px';
      btnSiguiente.style.fontSize = '40px';
      btnAnterior.style.width = '44px';
      btnSiguiente.style.width = '44px';
      btnAnterior.style.left = '5px';
      btnSiguiente.style.right = '5px';
    }
    
    // Evento táctil para mostrar flechas en móvil
    visor.addEventListener('touchstart', function() {
      btnAnterior.style.opacity = '0.8';
      btnSiguiente.style.opacity = '0.8';
      
      clearTimeout(window.flechasTimeout);
      window.flechasTimeout = setTimeout(function() {
        btnAnterior.style.opacity = '0.3';
        btnSiguiente.style.opacity = '0.3';
      }, 2000);
    });
    
    contenedorImg.appendChild(visorImg);
    contenedorImg.appendChild(cerrar);
    contenedorImg.appendChild(btnAnterior);
    contenedorImg.appendChild(btnSiguiente);
    visor.appendChild(contenedorImg);
    visor.appendChild(contador);
    document.body.appendChild(visor);
    
    // Eventos de cierre
    cerrar.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      visor.style.display = 'none';
    };
    
    visor.onclick = function(e) {
      if (e.target === visor) {
        visor.style.display = 'none';
      }
    };
    
    btnAnterior.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      navegarImagen(-1);
    };
    
    btnSiguiente.onclick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      navegarImagen(1);
    };
    
    // Navegación con teclado
    document.addEventListener('keydown', function(e) {
      if (visor.style.display !== 'flex') return;
      
      if (e.key === 'Escape') {
        visor.style.display = 'none';
      } else if (e.key === 'ArrowLeft') {
        navegarImagen(-1);
      } else if (e.key === 'ArrowRight') {
        navegarImagen(1);
      }
    });
    
    // Navegación táctil (swipe)
    var touchStartX = 0;
    var touchEndX = 0;
    
    visor.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    visor.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      if (touchEndX < touchStartX - 50) {
        navegarImagen(1); // Swipe izquierda → siguiente
      } else if (touchEndX > touchStartX + 50) {
        navegarImagen(-1); // Swipe derecha → anterior
      }
    }, { passive: true });
  }
  
  function navegarImagen(direccion) {
    if (imagenesVisor.length === 0) return;
    
    indiceActual = (indiceActual + direccion + imagenesVisor.length) % imagenesVisor.length;
    
    visorImg.style.opacity = '0';
    setTimeout(function() {
      visorImg.src = imagenesVisor[indiceActual];
      visorImg.style.opacity = '1';
      actualizarContador();
    }, 150);
  }
  
  function actualizarContador() {
    var contador = document.getElementById('visor-contador');
    if (contador) {
      contador.textContent = `${indiceActual + 1} / ${imagenesVisor.length}`;
    }
  }
  
  function abrirVisor(src, imagenes) {
    crearVisor();
    imagenesVisor = imagenes;
    indiceActual = imagenesVisor.indexOf(src);
    if (indiceActual === -1) indiceActual = 0;
    
    visorImg.src = src;
    visor.style.display = 'flex';
    actualizarContador();
    
    // Resetear timeout de flechas en móvil
    if (window.innerWidth <= 768) {
      clearTimeout(window.flechasTimeout);
      setTimeout(function() {
        var btnAnt = document.querySelector('#visor-imagenes button:first-of-type');
        var btnSig = document.querySelector('#visor-imagenes button:last-of-type');
        if (btnAnt && btnSig) {
          btnAnt.style.opacity = '0.3';
          btnSig.style.opacity = '0.3';
        }
      }, 3000);
    }
  }
  
  // ============================================
  // CAPTURAR CLICS EN IMÁGENES
  // ============================================
  document.addEventListener('click', function(e) {
    var img = e.target.closest('.product__media-item img, [data-media-id] img');
    
    if (img) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Obtener todas las imágenes visibles de la variante actual
      var imagenesVisibles = Array.from(document.querySelectorAll('.product__media-item:not([style*="none"]) img'))
        .map(function(img) { return img.src; });
      
      if (imagenesVisibles.length > 0) {
        abrirVisor(img.src, imagenesVisibles);
      }
      
      return false;
    }
  }, true);
  
  // ============================================
  // FUNCIONES DE FILTRADO
  // ============================================
  function forzarCargaImagenes() {
    var imagenes = document.querySelectorAll('.product__media-item img[loading="lazy"]');
    imagenes.forEach(function(img) {
      img.setAttribute('loading', 'eager');
    });
  }
  
  function reordenarImagenes() {
    var listaMedios = document.querySelector('.product__media-list');
    if (!listaMedios) return;
    
    var itemsVisibles = Array.from(document.querySelectorAll('.product__media-item:not([style*="none"])'));
    if (itemsVisibles.length <= 1) return;
    
    var itemsConOrden = itemsVisibles.map(function(item) {
      var img = item.querySelector('img');
      var alt = img ? img.getAttribute('alt') || '' : '';
      var numeroMatch = alt.match(/(\d{2})$/);
      var numero = numeroMatch ? parseInt(numeroMatch[1], 10) : 999;
      
      return {
        elemento: item,
        numero: numero,
        alt: alt
      };
    });
    
    itemsConOrden.sort(function(a, b) {
      return a.numero - b.numero;
    });
    
    itemsConOrden.forEach(function(item) {
      listaMedios.appendChild(item.elemento);
    });
    
    forzarCargaImagenes();
    window.dispatchEvent(new Event('resize'));
  }
  
  function filtrarPorVariante() {
    var seleccionada = document.querySelector('.product-form__input input[type="radio"]:checked + label');
    if (!seleccionada) return;
    
    var nombre = seleccionada.innerText.trim().toLowerCase();
    var codigo = codigosVariantes[nombre] || '';
    
    if (!codigo) return;
    
    var items = document.querySelectorAll('.product__media-item, [data-media-id]');
    var imagenesAMostrar = [];
    
    var regex = new RegExp('\\b' + codigo + '\\b', 'i');
    
    items.forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      
      var alt = img.getAttribute('alt') || '';
      
      if (regex.test(alt)) {
        imagenesAMostrar.push(item);
      }
    });
    
    items.forEach(function(item) {
      item.style.display = 'none';
    });
    
    imagenesAMostrar.forEach(function(item) {
      item.style.display = '';
    });
    
    setTimeout(reordenarImagenes, 50);
    setTimeout(forzarCargaImagenes, 100);
    
    if (window.innerWidth < 768 && imagenesAMostrar.length > 0) {
      setTimeout(function() {
        var primerSlide = document.querySelector('.product__media-item:not([style*="none"])');
        if (primerSlide) {
          primerSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }, 150);
    }
  }
  
  function asignarEventos() {
    var botones = document.querySelectorAll('.product-form__input input[type="radio"]');
    botones.forEach(function(boton) {
      boton.removeEventListener('change', filtrarPorVariante);
      boton.addEventListener('change', filtrarPorVariante);
    });
  }
  
  // Inicializar
  setTimeout(function() {
    asignarEventos();
    filtrarPorVariante();
    forzarCargaImagenes();
  }, 1000);
  
  var observer = new MutationObserver(function() {
    asignarEventos();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  console.log('✅ Visor de imágenes con flechas sutiles activado');
});